angular.module('bizmetryApp').controller('CreateRoleDialogController', function (
    $scope, $mdDialog, allPermissions, allRoles
) {
    $scope.allPermissions      = allPermissions || [];
    $scope.filteredPermissions = $scope.allPermissions;

    $scope.allRoles      = allRoles || [];
    $scope.filteredRoles = $scope.allRoles;

    $scope.creating = false;

    // Which checklist is currently shown — 'permissions' | 'roles'
    $scope.activeTab = 'permissions';

    $scope.newRole = {
        name:        '',
        description: ''
    };

    $scope.search = { query: '' };

    // Selection counts are kept as plain scope properties (updated only on
    // toggle/clear) instead of getSelectedCount()/getSelectedRoleCount()
    // functions. With ~100+ rows in each list, every digest cycle — which
    // fires on *every* keystroke anywhere in the dialog, including typing
    // the role name — was re-invoking those functions from several
    // ng-if/interpolation bindings. Same reasoning for permission._selected
    // / role._selected below: a plain property read is a much cheaper thing
    // for Angular's dirty-checking to evaluate per row, per digest, than a
    // function call that does a hash-map lookup.
    $scope.selectedCount     = 0;
    $scope.selectedRoleCount = 0;

    var _selectedPermissionMap = {};
    var _selectedRoleMap       = {};

    // ── Tabs ──────────────────────────────────────────────────────────
    $scope.setActiveTab = function (tab) {
        if ($scope.activeTab === tab) return;
        $scope.activeTab = tab;
        $scope.search.query = '';
        $scope.onSearchChange();
    };

    // ── Search (applies to whichever tab is active) ─────────────────────
    $scope.onSearchChange = function () {
        var q = ($scope.search.query || '').trim().toLowerCase();

        if ($scope.activeTab === 'roles') {
            if (!q) {
                $scope.filteredRoles = $scope.allRoles;
            } else {
                $scope.filteredRoles = $scope.allRoles.filter(function (r) {
                    return (r.name && r.name.toLowerCase().indexOf(q) !== -1) ||
                           (r.id && String(r.id).toLowerCase().indexOf(q) !== -1) ||
                           (r.description && r.description.toLowerCase().indexOf(q) !== -1);
                });
            }
            return;
        }

        if (!q) {
            $scope.filteredPermissions = $scope.allPermissions;
            return;
        }
        $scope.filteredPermissions = $scope.allPermissions.filter(function (p) {
            return (p.name && p.name.toLowerCase().indexOf(q) !== -1) ||
                   (p.id && p.id.toLowerCase().indexOf(q) !== -1) ||
                   (p.description && p.description.toLowerCase().indexOf(q) !== -1);
        });
    };

    $scope.clearSearch = function () {
        $scope.search.query = '';
        $scope.onSearchChange();
    };

    // ── Permission selection ─────────────────────────────────────────
    $scope.togglePermission = function (permission) {
        if (_selectedPermissionMap[permission.id]) {
            delete _selectedPermissionMap[permission.id];
            permission._selected = false;
        } else {
            _selectedPermissionMap[permission.id] = permission;
            permission._selected = true;
        }
        $scope.selectedCount = Object.keys(_selectedPermissionMap).length;
    };

    $scope.clearSelection = function () {
        Object.keys(_selectedPermissionMap).forEach(function (id) {
            _selectedPermissionMap[id]._selected = false;
        });
        _selectedPermissionMap = {};
        $scope.selectedCount = 0;
    };

    // ── Role selection ───────────────────────────────────────────────
    $scope.toggleRole = function (role) {
        if (_selectedRoleMap[role.id]) {
            delete _selectedRoleMap[role.id];
            role._selected = false;
        } else {
            _selectedRoleMap[role.id] = role;
            role._selected = true;
        }
        $scope.selectedRoleCount = Object.keys(_selectedRoleMap).length;
    };

    $scope.clearRoleSelection = function () {
        Object.keys(_selectedRoleMap).forEach(function (id) {
            _selectedRoleMap[id]._selected = false;
        });
        _selectedRoleMap = {};
        $scope.selectedRoleCount = 0;
    };

    // ── Form validity ─────────────────────────────────────────────────
    // Name is required; so is at least one DIRECT permission (child roles
    // don't count toward this — a role must define at least one permission
    // of its own, even if it also inherits more via nested child roles).
    $scope.isFormValid = function () {
        return !!($scope.newRole.name && $scope.newRole.name.trim()) && $scope.selectedCount > 0;
    };

    $scope.getFormHint = function () {
        var hasName = !!($scope.newRole.name && $scope.newRole.name.trim());
        if (!hasName && $scope.selectedCount === 0) {
            return 'Role name and at least one permission are required';
        }
        if (!hasName) {
            return 'Role name is required';
        }
        return 'Select at least one permission';
    };

    // ── Actions ───────────────────────────────────────────────────────
    $scope.create = function () {
        if (!$scope.isFormValid() || $scope.creating) return;
        $scope.creating = true;

        var selectedPermissions = Object.keys(_selectedPermissionMap).map(function (id) {
            return _selectedPermissionMap[id];
        });

        var selectedRoles = Object.keys(_selectedRoleMap).map(function (id) {
            return _selectedRoleMap[id];
        });

        $mdDialog.hide({
            name:        $scope.newRole.name.trim(),
            description: ($scope.newRole.description || '').trim(),
            permissions: selectedPermissions,
            childRoles:  selectedRoles
        });
    };

    $scope.cancel = function () { $mdDialog.cancel(); };
});
